import { TableCell } from "@mui/material"
import classNames from "classnames"
import { Icon, IconColor } from "@/components/shared/Icon"
import Tooltip from "@/components/shared/Tooltip"

export interface ActionsBulkProps {
   isDisabled: boolean
   isSaveDisabled?: boolean
   isFirstEditableRow?: boolean
   onSave: () => void
   onCancel: () => void
   onDelete: () => void
}

export function ActionsBulk({
   isDisabled,
   isSaveDisabled = false,
   isFirstEditableRow,
   onSave,
   onCancel,
   onDelete,
}: ActionsBulkProps) {
   return (
      <TableCell
         className="table__cell table__cell--actions"
         align="right"
      >
         <div
            className={classNames("table__actions", {
               "table__actions--disabled": isDisabled,
            })}
         >
            {isFirstEditableRow && (
               <Tooltip
                  key="cancel-tooltip"
                  content="Cancel"
               >
                  <Icon
                     name="cross"
                     color={IconColor.HONOLULU_BLUE}
                     size="16"
                     onClick={onCancel}
                  />
               </Tooltip>
            )}
            <Tooltip
               key="delete-tooltip"
               content="Delete"
            >
               <Icon
                  name="trashBin"
                  color={IconColor.CERISE}
                  size="16"
                  onClick={onDelete}
               />
            </Tooltip>
            {isFirstEditableRow && (
               <Tooltip
                  key="save-tooltip"
                  content="Save"
               >
                  <Icon
                     name="save"
                     color={IconColor.HONOLULU_BLUE}
                     size="16"
                     onClick={onSave}
                     aria-label="Save"
                     disabled={isSaveDisabled}
                  />
               </Tooltip>
            )}
         </div>
      </TableCell>
   )
}
